import React from 'react';
import styled from 'styled-components';
import getBackgroundColor from '../get-background-color';

const getBorderColor = (theme, border) => {
  switch (border) {
    case 'top':
      return `
        border-top-width: 1px;
      `;
    case 'bottom':
      return `
        border-bottom-width: 1px;
      `;
    case 'top_and_bottom':
      return `
        border-top-width: 1px;
        border-bottom-width: 1px;
      `;
    default:
      return '';
  }
};

const StyledColor = styled.div`
  background-color: ${({ theme, $color, $customColor }) => getBackgroundColor(theme, $color, $customColor)};
  border-width: 0;
  border-style: solid;
  border-color: ${({ theme }) => theme.gray02};
  ${({ theme, $border }) => getBorderColor(theme, $border)}
`;

const Color = ({
  className,
  color,
  customColor,
  border,
  children,
}) => {
  if (color) {
    return (
      <StyledColor
        className={className}
        $color={color}
        $customColor={customColor}
        $border={border}
      >
        {children}
      </StyledColor>
    );
  }
  return <div className={className}>{children}</div>;
};

export default Color;
